import React from 'react';
import PropTypes from 'prop-types';

import styles from './StockLabel.css';

const IPropTypes = {
  darkMode: PropTypes.bool,
  product: PropTypes.oneOf(['available', 'low', 'none']).isRequired,
};

const defaultProps = {
  darkMode: false,
};

const stringifyStockLevel = (product) => {
  const piece = product.notAbleToSellString && product.notAbleToSellString.split(' disponible ');
  let stockLevelMessage = `Sin stock. Fecha estimada: ${piece && piece.length > 1 ? piece[1] : '-'}.`;
  if (!product.shouldShowPrice()) {
    stockLevelMessage += 'Fijado el precio se publicará inmediatamente.';
  }
  switch (product.stockLevel) {
    case 'available':
      return 'Stock disponible';
    case 'low':
      return 'Stock disponible, últimas unidades';
    case 'almostNone':
      return 'No hay, o hay muy poco';
    case 'none':
      return stockLevelMessage;
    default:
      return '';
  }
};

const StockLabel = (props) => {
  let stylingClass = styles.available;
  if (props.product.stockLevel !== 'available') {
    stylingClass = styles.none;
  }
  const darkModeClass = props.darkMode ? styles.dark : '';
  return (
    <div className={[styles.container, stylingClass, darkModeClass].join(' ')}>
      {stringifyStockLevel(props.product)}
    </div>
  );
};

StockLabel.propTypes = IPropTypes;
StockLabel.defaultProps = defaultProps;

export { StockLabel };



// WEBPACK FOOTER //
// ./src/pages/product-detail/stock-label/StockLabel.jsx